export const selectToken = (state) => state.clients.token;

export const selectClient = (state) => state.clients;
